import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal, Select } from 'antd'
import Loader from '../../pages/pages/loader'
import {
  useCreateUserMutation,
  useUpdateUserMutation
} from '../../redux/apis/usersManagement/users/uMUsersApiSlice'
import CustomersDropdown from '../CustomersDropdown'

const EditCreateCustomerUser = ({ state, open, setOpen, record }) => {
  const [
    updateUser,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateUserMutation()
  const [
    addUser,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateUserMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: record?.first_name,
      last_name: record?.last_name,
      email: record?.email,
      password: record?.password,
      sm_user_id: record?.sm_user_id,
      is_customer:record?.is_customer,
      is_active: state === 'edit' ? record?.is_active : true,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      first_name: Yup.string().required('Please Enter First Name'),
      last_name: Yup.string().required('Please Enter Last Name'),
      email: Yup.string().required('Please Enter Email'),
      is_customer: Yup.number().required('Please Choose Customer'),
      password: Yup.string(),
      is_active: Yup.boolean().required('Please Choose User Status')
    }),

    onSubmit: async values => {
      const payload = { ...values }

      // Remove password field if it's empty or undefined
      if (!payload.password) {
        delete payload.password
      }
      if(!payload.sm_user_id){
        delete payload.sm_user_id
      }

      try {
        if (state === 'edit') {
          await updateUser({
            body: payload, // Send plain JSON
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addUser(payload).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('User created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('User updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])
  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit User` : 'Create User'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      <div className=' mb-3'>
        <label className="form-label">First Name</label>
        <Input
          type='text'
          name='first_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.first_name}
        />
        {validation.touched.first_name && validation.errors.first_name ? (
          <p className='text-danger'>{validation.errors.first_name}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Last Name</label>
        <Input
          type='text'
          name='last_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.last_name}
        />
        {validation.touched.last_name && validation.errors.last_name ? (
          <p className='text-danger'>{validation.errors.last_name}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Email</label>
        <Input
          type='text'
          name='email'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.email}
        />
        {validation.touched.email && validation.errors.email ? (
          <p className='text-danger'>{validation.errors.email}</p>
        ) : null}
      </div>
      
      <div className=' mb-3'>
        <label className="form-label">Password</label>
        <Input
          type='password'
          name='password'
          autoComplete='new-password'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.password}
        />
        {validation.touched.password && validation.errors.password ? (
          <p className='text-danger'>{validation.errors.password}</p>
        ) : null}
      </div>
      
      <div className=' mb-3'>
        <CustomersDropdown
          onChange={e => {
            validation.setFieldValue('is_customer', e)
          }}
          value={validation.values.is_customer}
          onBlur={validation.handleBlur}
          
        />
        {validation.touched.is_customer && validation.errors.is_customer ? (
          <p className='text-danger'>{validation.errors.is_customer}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Social Media ID</label>
        <Input
          type='text'
          name='sm_user_id'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.sm_user_id}
        />
        {validation.touched.sm_user_id && validation.errors.sm_user_id ? (
          <p className='text-danger'>{validation.errors.sm_user_id}</p>
        ) : null}
      </div>
      <div className='mb-3'>
        <label className="form-label">Status</label>
        <br />
        <Select
          name='is_active'
          style={{
            width: '100%'
          }}
          onBlur={validation.handleBlur}
          onChange={e => {
            validation.setFieldValue('is_active', e)
          }}
          value={validation.values?.is_active}
          options={[
            { label: 'Active', value: true },
            { label: 'InActive', value: false }
          ]}
        />
        {validation.touched.is_active && validation.errors.is_active ? (
          <p className='text-danger'>{validation.errors.is_active}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateCustomerUser
